'use strict';
var angular = require('angular');

var authIntegrationCtrl = [function () {
    var _this = this;

    if (!_this.auth) {
        _this.auth = {
            type: ''
        };
    } else if (_this.auth.type === undefined || _this.auth.type === null) {
        _this.auth.type = '';
    }
}];

module.exports = function () {
    return {
        restrict: 'E',
        scope: {
            auth: '=',
            readOnly: '=?'
        },
        controller: authIntegrationCtrl,
        controllerAs: 'ctrl',
        bindToController: true,
        templateUrl: 'directives/authIntegrationDirective.html'
    };
};
